import { useEffect, useState } from 'react';
import { Button } from '../Button';
import { Icons } from '../Icons';
import { Input } from '../Input';

const QuantityBox = ({
  quantity,
  onChange,
  minQuantity = 0,
  maxQuantity,
  disabled,
}: {
  quantity: number;
  onChange: (qty: number) => void;
  minQuantity?: number;
  maxQuantity?: number;
  disabled?: boolean;
}) => {
  const [qty, setQty] = useState<number>(quantity);

  useEffect(() => {
    setQty(quantity);
  }, [quantity]);

  const handleDecrease = () => {
    const newQty = Math.max(minQuantity, qty - 1);
    setQty(newQty);
    onChange(newQty);
  };

  const handleIncrease = () => {
    if (maxQuantity && qty + 1 > maxQuantity) return;
    const newQty = qty + 1;
    setQty(newQty);
    onChange(newQty);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value) || minQuantity;
    let newQty = value;

    // Enforce min/max boundaries
    if (value < minQuantity) {
      newQty = minQuantity;
    } else if (maxQuantity && value > maxQuantity) {
      newQty = maxQuantity;
    }

    setQty(newQty);
    onChange(newQty);
  };

  return (
    <div className="flex items-center border border-border-primary rounded-md bg-white">
      <Button
        variant="tertiary"
        size="sm"
        onClick={handleDecrease}
        className="bg-white hover:bg-white"
        disabled={disabled || qty <= minQuantity}
      >
        <Icons.Minus className="w-4 h-4" />
      </Button>
      <Input
        type="number"
        min={minQuantity}
        max={maxQuantity || 999}
        value={qty}
        onChange={handleInputChange}
        className="w-16 h-8 text-sm text-center border border-border-primary border-t-0 border-b-0 bg-bg-secondary rounded-none"
        disabled={disabled}
      />
      <Button
        variant="tertiary"
        size="sm"
        onClick={handleIncrease}
        disabled={disabled || (maxQuantity !== undefined && qty >= maxQuantity)}
        className="bg-white hover:bg-white"
      >
        <Icons.Plus className="w-4 h-4" />
      </Button>
    </div>
  );
};

export { QuantityBox };
